export const HEXCOLOR_REGEX = /^[0-9a-fA-F]{6}$/;
export const FALLBACK_COLOR = "000000"; // black
